export const colors = {
  primary: 'var(--mantine-color-primary-6)',
  success: 'var(--mantine-color-success-7)',
  warning: 'var(--mantine-color-warning-6)',
  error: 'var(--mantine-color-error-6)',
  info: 'var(--mantine-color-info-6)',
  pink: 'var(--mantine-color-pink-6)',
  border: '#FFFFFF1A',
  white: '#FFFFFF',
  gray: 'var(--mantine-color-gray-4)',
  black: '#000000',
  orange: 'var(--mantine-color-orange-6)',
  lightGray: '#5a6680',
  lightGreen: '#e6faf3',
  neutralGray: '#aeb7d6'
} as const
